var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.currentFrame,
            expression: "currentFrame",
            modifiers: { number: true }
          }
        ],
        attrs: { type: "range", min: 0, max: 2500 },
        domProps: { value: _vm.currentFrame },
        on: {
          __r: function($event) {
            _vm.currentFrame = _vm._n($event.target.value)
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" Current Frame = " + _vm._s(_vm.currentFrame) + " "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.myCamera.x,
            expression: "myCamera.x",
            modifiers: { number: true }
          }
        ],
        attrs: { type: "range", min: 0, max: 600 },
        domProps: { value: _vm.myCamera.x },
        on: {
          __r: function($event) {
            _vm.$set(_vm.myCamera, "x", _vm._n($event.target.value))
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" X = " + _vm._s(_vm.myCamera.x) + " "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.myCamera.y,
            expression: "myCamera.y",
            modifiers: { number: true }
          }
        ],
        attrs: { type: "range", min: 0, max: 1200 },
        domProps: { value: _vm.myCamera.y },
        on: {
          __r: function($event) {
            _vm.$set(_vm.myCamera, "y", _vm._n($event.target.value))
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" Y = " + _vm._s(_vm.myCamera.y) + " "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.zoom,
            expression: "zoom",
            modifiers: { number: true }
          }
        ],
        attrs: { type: "range", min: 0, max: 10 },
        domProps: { value: _vm.zoom },
        on: {
          __r: function($event) {
            _vm.zoom = _vm._n($event.target.value)
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" Zoom = " + _vm._s(_vm.zoom) + " "),
      _c("ocean-scene", {
        staticStyle: { fill: "#90CDF4" },
        attrs: {
          align: "topleft",
          overflow: "hidden",
          camera: _vm.myCamera,
          keyframe: _vm.keyframe
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }